module.exports = __webpack_public_path__ + "img/fruits-lemon.d441a327.svg";